import { DraggableModalPanel } from '../../components/ui/DraggableModalPanel';
import { MonitoringLogEntry } from '../../services/monitoringApi';

type MonitoringLogDetailModalProps = {
  entry: MonitoringLogEntry | null;
  open: boolean;
  onClose: () => void;
};

export function MonitoringLogDetailModal({
  entry,
  open,
  onClose,
}: MonitoringLogDetailModalProps) {
  if (!entry) {
    return null;
  }

  const isException = entry.level === 'Exception'
    || Boolean(entry.exceptionType)
    || Boolean(entry.stackTrace);

  return (
    <DraggableModalPanel
      open={open}
      title="Detalhes do log"
      subtitle={`${entry.level} · ${new Date(entry.timestampUtc).toLocaleString('pt-BR')}`}
      onClose={onClose}
      className="w-full max-w-3xl"
      footer={(
        <button type="button" className="erp-btn-secondary" onClick={onClose}>
          Fechar
        </button>
      )}
    >
      <div className="space-y-4 text-sm">
        {entry.source ? (
          <div>
            <p className="font-medium text-secondary-700">Origem</p>
            <p className="mt-1 break-all text-secondary-600">{entry.source}</p>
          </div>
        ) : null}
        {entry.requestPath ? (
          <div>
            <p className="font-medium text-secondary-700">Rota</p>
            <p className="mt-1 break-all text-secondary-600">{entry.requestPath}</p>
          </div>
        ) : null}
        {entry.traceId ? (
          <div>
            <p className="font-medium text-secondary-700">Trace</p>
            <p className="mt-1 break-all text-secondary-600">{entry.traceId}</p>
          </div>
        ) : null}
        <div>
          <p className="font-medium text-secondary-700">Mensagem</p>
          <pre className="mt-1 max-h-48 overflow-auto whitespace-pre-wrap rounded-lg bg-secondary-50 p-3 text-xs text-secondary-700">
            {entry.message}
          </pre>
        </div>
        {isException ? (
          <>
            {entry.exceptionType ? (
              <div>
                <p className="font-medium text-secondary-700">Tipo da exception</p>
                <p className="mt-1 break-all text-rose-700">{entry.exceptionType}</p>
              </div>
            ) : null}
            {entry.exceptionMessage ? (
              <div>
                <p className="font-medium text-secondary-700">Mensagem da exception</p>
                <pre className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap rounded-lg bg-rose-50 p-3 text-xs text-rose-800">
                  {entry.exceptionMessage}
                </pre>
              </div>
            ) : null}
            {entry.stackTrace ? (
              <div>
                <p className="font-medium text-secondary-700">Stack trace</p>
                <pre className="mt-1 max-h-80 overflow-auto whitespace-pre-wrap rounded-lg bg-secondary-50 p-3 text-xs text-secondary-700">
                  {entry.stackTrace}
                </pre>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </DraggableModalPanel>
  );
}
